import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import EStores from '../../enums/EStores.ts';
import IAd, {IAdFile} from "../../interfaces/IAd.ts";

type IStore = {
  advertisement?: IAd
  adFiles?: IAdFile[];
}

const initialState: IStore = {};

const store = createSlice({
  name: EStores.ADVERTISEMENT_ADMIN,
  initialState,
  reducers: {
    setAd(state: IStore, statement: PayloadAction<IAd>) {
      state.advertisement = statement.payload
      return state
    },
    setAdFiles(state: IStore, parentMovements: PayloadAction<IAdFile[]>) {
      state.adFiles = parentMovements.payload
      return state
    },
    clearAd(state: IStore) {
      state.advertisement = undefined
      state.adFiles = []
      return
    },
  },
});

export const {
  setAd,
  setAdFiles,
  clearAd,
} = store.actions;

export default store.reducer;
